import React from "react";
import { Col, Container, Row } from "reactstrap";
import Widget from "./Widgets";
import BestSellingProducts from "./BestSellingProducts";
import RecentOrders from "./RecentOrders";
import Revenue from "./Revenue";
import Section from "./Section";


const DashboardEcommerce = () => {
  document.title ="Dashboard | Confidoo";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Section />
                <Row>
                  <Widget />
                </Row>
                <Row>
                  <Col>
                    <Revenue />
                  </Col>
                </Row>
                <Row>
                  <BestSellingProducts />
                </Row>
                <Row>
                  <RecentOrders />
                </Row>
              </div>
            </Col>

          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
